"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class handles communication with the IRW application through post message.
 */
var IrwPlatformCommunication = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.applicationName Application name.
     */
    function IrwPlatformCommunication(options) {
        this.applicationName = null;
        this.applicationName = options.applicationName;
    }
    /**
     * Sets the iframe container height.
     *
     * @param height Height to set.
     */
    IrwPlatformCommunication.prototype.setIframeHeight = function (height) {
        if (utilities_1.IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                header: {
                    name: 'setContainerSize'
                },
                body: {
                    height: height,
                    containerName: this.getContainerName()
                }
            }, '*');
        }
    };
    /**
     * Sets the cart count.
     *
     * @param cartCount Cart count to set.
     */
    IrwPlatformCommunication.prototype.setCartCount = function (cartCount) {
        if (utilities_1.IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                header: {
                    name: 'shoppingcartCount'
                },
                body: {
                    count: cartCount,
                    containerName: this.getContainerName()
                }
            }, '*');
        }
    };
    /**
     * Returns the iframe container name.
     *
     * @returns Iframe container name.
     */
    IrwPlatformCommunication.prototype.getContainerName = function () {
        return '#' + this.applicationName + '-application';
    };
    return IrwPlatformCommunication;
}());
exports.default = IrwPlatformCommunication;
//# sourceMappingURL=IrwPlatformCommunication.js.map